import React, { useEffect, useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { useSelector, useDispatch } from 'react-redux';
import { loadUser, updatePaymentReminder } from '../../actions/userActions'
import { useHistory } from 'react-router';
import { url } from '../../config';
import { FormattedMessage, useIntl } from "react-intl";


function SubscriptionExpired(props) {
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch()
    const history = useHistory()


    useEffect(() => {
        if (props?.data) {
            if (props?.data?.is_payment_reminder == "-1") {
                setShowModal(true)
            } else {
                setShowModal(false)
            }
        }
    }, [props])


    //update-payment-failed-retry
    const handleSubmit = (type) => {
        if (type == 'cancel') {
            setShowModal(false)
            dispatch(updatePaymentReminder())
            dispatch(loadUser())
        } else {
            setShowModal(false)
            dispatch(updatePaymentReminder())
            history.push(url + `/plan-details`);
            dispatch(loadUser())
        }
    }

    return (
        <div className="container mt-5">
            {showModal && (
                <>
                    <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content" style={{ borderRadius: '15px' }}>
                                <button
                                    type="button"
                                    className="close"
                                    aria-label="Close"
                                    onClick={() => { handleSubmit('cancel') }}
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        right: '15px',
                                        fontSize: '28px',
                                        fontWeight: 'bold',
                                        color: '#78777cff',
                                        opacity: 0.8,
                                        cursor: 'pointer',
                                        zIndex: 10
                                    }}
                                >
                                    {/* This symbol × (not *) */}
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <div className="modal-body text-center p-4" style={{ backgroundColor: 'white', borderRadius: '10px' }}>
                                    <h4 className="mb-3" style={{ fontWeight: '700', color: '#c0392b' }}>
                                        <FormattedMessage id='SubscriptionExpired' defaultMessage="SubscriptionExpired" />
                                    </h4>

                                    <p className="text-muted mt-3" style={{ fontSize: '14px', lineHeight: '1.7', textAlign: 'left' }}>
                                        <FormattedMessage id='Dear' defaultMessage="Dear" /> {props?.data?.name},
                                        <br /><br />
                                        {/* <FormattedMessage id="RapaportMidfirst" defaultMessage="RapaportMidfirst"/> <strong>{new Date().toLocaleDateString('en-US')}</strong>, <FormattedMessage defaultMessage="RapaportMidSecond" id='RapaportMidSecond'/> */}
                                    </p>

                                    <p className="text-muted mt-3" style={{ fontSize: '14px', lineHeight: '1.7', textAlign: 'left' }}>
                                        <FormattedMessage id="SubscriptionExpiredMessage" defaultMessage="SubscriptionExpiredMessage" />


                                        <a style={{ color: 'black' }}><FormattedMessage id='SubscriptionExpiredMessageSecond' defaultMessage='PaymentReNewMainSecond' /></a>. {' '}

                                        {/* <FormattedMessage id="PaymentReNewMainSecond" defaultMessage="PaymentReNewMainSecond"/> */}
                                        <FormattedMessage id="SubscriptionExpiredMessageThree" defaultMessage="SubscriptionExpiredMessageThree" />

                                    </p>

                                    <a
                                        className="btn btn-primary btn-sm btnFUll_Bg"
                                        style={{
                                            fontSize: '15px',
                                            fontWeight: '500',
                                            borderRadius: '8px',
                                            color: 'white',
                                            // backgroundColor: '#1a3974'
                                        }}
                                        onClick={() => { handleSubmit('renew') }}
                                    >
                                        <FormattedMessage id='RenewNow' defaultMessage='RenewNow' />
                                    </a>

                                    {/* <p className="text-muted mt-3" style={{ fontSize: '13px', textAlign: 'left' }}>
                                        <FormattedMessage id='personal_assistance'  defaultMessage='personal_assistance'/>{' '}
                                        <a href="#" style={{ color: '#6c63ff', textDecoration: 'none' }}><FormattedMessage id='myaccount.contactus' defaultMessage='myaccount.contactus'/></a>.
                                        <br />
                                        <FormattedMessage id='Were_here_to_help' defaultMessage='Were_here_to_help'/>
                                    </p>

                                    <p className="text-muted mt-3" style={{ fontSize: '13px', textAlign: 'left' }}>
                                        <FormattedMessage defaultMessage='RapaportThank' id='RapaportThank'/>
                                    </p>

                                    <p className="text-muted mt-3" style={{ fontSize: '13px', textAlign: 'left' }}>
                                        <FormattedMessage id='Kind regards' defaultMessage='Kind regards'/>,<br />
                                        <strong><FormattedMessage id='TheCevaheerTeam' defaultMessage='TheCevaheerTeam'/></strong><br />
                                        <FormattedMessage id='CustomerSupport' defaultMessage='CustomerSupport' />: <a href="mailto:help@cevaheer.net" style={{ color: '#6c63ff', textDecoration: 'none' }}>help@cevaheer.net</a><br />
                                        <a href="https://www.cevaheer.com" style={{ color: '#6c63ff', textDecoration: 'none' }}>www.cevaheer.com</a>
                                    </p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
export default SubscriptionExpired